<template>

    <div class="tabs-inspection panel panel-default">
        <ul class="nav nav-tabs">
            <li :class="{active: activated == 0}">
                <a @click="activated = 0">
                    Основные
                </a>
            </li>
            <li :class="{active: activated == 1}">
                <a @click="activated = 1">
                    Комплектация
                </a>
            </li>
            <li :class="{active: activated == 2}">
                <a @click="activated = 2">
                    Внешний осмотр
                </a>
            </li>
            <li :class="{active: activated == 3}">
                <a @click="activated = 3">
                    Внутренний осмотр
                </a>
            </li>
            <li :class="{active: activated == 4}">
                <a @click="activated = 4">
                    Тест драйв
                </a>
            </li>
            <li :class="{active: activated == 5}">
                <a @click="activated = 5">
                    Диагностика
                </a>
            </li>
        </ul>
        <inspection-main activated="0" v-show="activated == 0" :inspection_id="inspection_id"></inspection-main>
        <inspection-equipment activated="1" v-show="activated == 1" :inspection_id="inspection_id"></inspection-equipment>
        <inspection-external activated="2" v-show="activated == 2" :inspection_id="inspection_id" :door_count="door_count"></inspection-external>
        <inspection-internal activated="3" v-show="activated == 3" :inspection_id="inspection_id"></inspection-internal>
        <inspection-test-drive activated="4" v-show="activated == 4" :inspection_id="inspection_id"></inspection-test-drive>
        <inspection-diagnostic activated="5" v-show="activated == 5" :inspection_id="inspection_id"></inspection-diagnostic>
    </div>
</template>

<script>
    export default {
        name: 'TabsInspection',
        data() {
            return {
                activated: 0,
            }
        },
        props: [
            'inspection_id',
            'door_count'
        ],
    }
</script>

<style lang="less">
    @import "../../less/_boot";

    .tabs-inspection {
        .nav-tabs {
            border-width: 0;
            > li {
                > a {
                    font-size: 15px;
                    line-height: 81px;
                    color: #727378;
                    padding: 0px 32px;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                    cursor: pointer;
                    border-width: 3px 0 0 !important;
                    border-radius: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// TabsInspection.vue?51c77e9c